import React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const Shell = styled.div`
	display: flex;
	height: 100vh;
	width: 100%;

	@media (max-width: 900px) {
		flex-direction: column;
		height: auto;
		min-height: 100vh;
	}
`;

const Hero = styled.div`
	flex: 0 0 60%;
	background: url('/images/login-hero.webp') no-repeat center center / cover;

	@media (max-width: 900px) {
		flex: 0 0 auto;
		height: 40vh;
	}
`;

const Content = styled.div`
	flex: 1;
	background: #faf9f8;
	display: flex;
	align-items: center;
	min-width: 0;
`;

const Panel = styled.div`
	width: 100%;
	max-width: 600px;
	padding: 0 24px 0 64px;

	@media (max-width: 900px) {
		padding: 24px;
	}
`;

const Title = styled.h1`
	font-family: 'Akkurat', Arial, Helvetica, sans-serif;
	font-weight: 400;
	font-size: 48px;
	line-height: 1.2;
	color: #000000;
	margin: 0 0 24px;
`;

const Text = styled.p`
	font-size: 16px;
	line-height: 1.5;
	color: #555555;
	margin: 0 0 12px;
`;

export default ({ message }) => (
	<Shell>
		<Helmet title="Maintenance" />
		<Hero />
		<Content>
			<Panel>
				<Title>Bromma Backyard is under maintenance</Title>
				<Text>
					{message ||
						'We are currently performing scheduled maintenance. Please try again later.'}
				</Text>
				<Text>We apologize for any inconvenience.</Text>
			</Panel>
		</Content>
	</Shell>
);



// WEBPACK FOOTER //
// ./src/pages/Maintenance/index.js